export default "__VITE_ASSET__1nxH2tJQ__"